import apiService from '../apiService';

export const getAuditLogMeta = async () => {
    return apiService.GET('/api/admin/audit-logs/meta');
};

export const getAuditLogs = async (params = {}) => {
    return apiService.GET('/api/admin/audit-logs', params);
};

export const getAuditLogDetail = async (id) => {
    return apiService.GET(`/api/admin/audit-logs/${id}`);
};

export const exportAuditLogs = async (params = {}) => {
    return apiService.GET('/api/admin/audit-logs/export', params, {
        responseType: 'blob'
    });
};

export const startAuditLogExport = async (params = {}) => {
    return apiService.POST('/api/admin/audit-logs/exports', params);
};

export const getAuditLogExportStatus = async (exportId) => {
    return apiService.GET(`/api/admin/audit-logs/exports/${exportId}`);
};

export const downloadAuditLogExport = async (exportId) => {
    return apiService.GET(
        `/api/admin/audit-logs/exports/${exportId}/download`,
        {},
        {
            responseType: 'blob'
        }
    );
};
